import React from 'react';
import { EntityTypes } from '@wg/wows-entities/const';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import { Interpolate } from '@wg/wows-react-uikit';

import settings from '~/settings';
import { CLANSTARS_QUEST_TYPES } from '~/constants';
import { t } from '~/helpers/localization';

import type { IClanStarsQuest } from '~/Reducers/ReducerClanStars';

type IClanStarsQuestTitleProps = {
  quest: IClanStarsQuest;
  withEntities?: boolean;
  classNameWrapper?: string;
  classNameAchievement?: string;
};

const ClanStarsQuestTitle: React.FC<IClanStarsQuestTitleProps> = ({
  quest,
  withEntities = false,
  classNameWrapper,
  classNameAchievement,
}) => {
  let content: React.ReactNode = '';

  switch (quest.type) {
    case CLANSTARS_QUEST_TYPES.WIN_BATTLE: {
      content = t('Победить в бою');
      break;
    }
    case CLANSTARS_QUEST_TYPES.EARN_ACHIEVEMENT: {
      if (withEntities) {
        content = (
          <Interpolate
            str={t('Получить достижение  "%(maxClanProgress)s"')}
            maxClanProgress={
              <span className={classNameAchievement}>
                <WoWSEntity
                  type={EntityTypes.ACHIEVEMENT}
                  id={quest.data.achievement}
                  presentation={{
                    withTooltip: true,
                    renderWithoutFade: true,
                  }}
                />
              </span>
            }
            noWrap
          />
        );
      } else {
        const localization = settings.realm?.languageCodeGloss;
        content = (
          <Interpolate
            str={t('Получить достижение  "%(maxClanProgress)s"')}
            maxClanProgress={settings.achievements.data[quest.data.achievement].localization.mark[localization]}
            noWrap
          />
        );
      }
      break;
    }
  }

  return <div className={classNameWrapper}>{content}</div>;
};

export default React.memo(ClanStarsQuestTitle);
